import type React from 'react';
import { type ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  icon?: ReactNode | string;
  title?: string;
  message: string;
  action?: ReactNode;
  variant?: 'default' | 'centered' | 'compact';
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  message,
  action,
  variant = 'default',
}) => {
  return (
    <div className={`${styles.container} ${styles[variant]}`}>
      {icon && (
        <div className={styles.icon} aria-hidden="true">
          {typeof icon === 'string' ? <span>{icon}</span> : icon}
        </div>
      )}
      {title && <h3 className={styles.title}>{title}</h3>}
      <p className={styles.message}>{message}</p>
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};
